import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./node-content-renderer.scss";
import { ChevronDown, ChevronRight } from 'react-feather';

function isDescendant(older, younger) {
  return (
    !!older.children &&
    typeof older.children !== "function" &&
    older.children.some(
      (child) => child === younger || isDescendant(child, younger)
    )
  );
}

// eslint-disable-next-line react/prefer-stateless-function
class FileThemeNodeContentRenderer extends Component {
  render() {
    const {
      scaffoldBlockPxWidth,
      toggleChildrenVisibility,
      connectDragPreview,
      connectDragSource,
      isDragging,
      canDrop,
      canDrag,
      node,
      title,
      draggedNode,
      path,
      treeIndex,
      isSearchMatch,
      isSearchFocus,
      icons,
      buttons,
      className,
      style,
      didDrop,
      lowerSiblingCounts,
      listIndex,
      swapFrom,
      swapLength,
      swapDepth,
      treeId, // Not needed, but preserved for other renderers
      isOver, // Not needed, but preserved for other renderers
      parentNode, // Needed for dndManager
      rowDirection,
      ...otherProps
    } = this.props;
    const nodeTitle = title || node.title;

    const isDraggedDescendant = draggedNode && isDescendant(draggedNode, node);
    const isLandingPadActive = !didDrop && isDragging;

    // Construct the scaffold representing the structure of the tree
    const scaffold = [];
    lowerSiblingCounts.forEach((lowerSiblingCount, i) => {
      scaffold.push(
        <div
          key={`pre_${1 + i}`}
          style={{ width: scaffoldBlockPxWidth }}
          className={"rst-line-block"}
        />
      );

      if (treeIndex !== listIndex && i === swapDepth) {
        // This row has been shifted, and is at the depth of
        // the line pointing to the new destination
        let highlightLineClass = "";

        if (listIndex === swapFrom + swapLength - 1) {
          // This block is on the bottom (target) line
          // This block points at the target block (where the row will go when released)
          highlightLineClass = "rst-highlight-bottom-left-corner";
        } else if (treeIndex === swapFrom) {
          // This block is on the top (source) line
          highlightLineClass = "rst-highlight-top-left-corner";
        } else {
          // This block is between the bottom and top
          highlightLineClass = "rst-highlight-line-vertical";
        }

        scaffold.push(
          <div
            key={`highlight_${1 + i}`}
            style={{
              width: scaffoldBlockPxWidth,
              left: scaffoldBlockPxWidth * i,
            }}
            className={`rst-absolute-line-block ${highlightLineClass}`}
          />
        );
      }
    });

    const nodeContent = (
      <div style={{ height: "100%" }} {...otherProps}>
        {toggleChildrenVisibility && node.children && node.children.length > 0 && (
          <button
            type="button"
            aria-label={node.expanded ? "Collapse" : "Expand"}
            className={
              node.expanded ? "rst-collapse-btn" : "rst-expand-btn"
            }
            style={{
              left: (lowerSiblingCounts.length - 0.7) * scaffoldBlockPxWidth,
            }}
            onClick={() =>
              toggleChildrenVisibility({
                node,
                path,
                treeIndex,
              })
            }
          />
          // <button
          //   type="button"
          //   aria-label={node.expanded ? "Collapse" : "Expand"}
          //   style={{ left: (lowerSiblingCounts.length - 0.7) * scaffoldBlockPxWidth, }}
          //     onClick={() =>
          //     toggleChildrenVisibility({
          //       node,
          //       path,
          //       treeIndex,
          //     })
          //   }
          //   >
          //   <ChevronDown size={16} className="text-gray-400 absolute top-7" />
          // </button>
        )}

        <div
          className={
            "rst-row-wrapper" +
            (!canDrag ? ` rst-row-wrapper-drag-disabled` : "")
          }
        >
          {/* Set the row preview to be used during drag and drop */}
          {connectDragPreview(
            <div className="flex text-gray-500">
              {scaffold}
              <div
                className={
                  "rst-row" +
                  (isLandingPadActive ? ` rst-row-landing-pad` : "") +
                  (isLandingPadActive && !canDrop
                    ? ` rst-row-cancel-pad`
                    : "") +
                  (isSearchMatch ? ` rst-row-search-match` : "") +
                  (isSearchFocus ? ` rst-row-search-focus` : "") +
                  (className ? ` ${className}` : "")
                }
                style={{
                  opacity: isDraggedDescendant ? 0.5 : 1,
                  ...style,
                }}
              >
                <div
                  className={
                    "rst-row-contents flex items-center" +
                    (!canDrag ? ` rst-row-contents-drag-disabled` : "")
                  }
                >
                  <div className={"rst-row-toolbar"}>
                    {icons.map((icon, index) => (
                      <div
                        key={index} // eslint-disable-line react/no-array-index-key
                        className={"rst-toolbar-btn"}
                      >
                        {icon}
                      </div>
                    ))}
                  </div>
                  <div className="rst-row-label">
                    <span className="rst-row-title text-sm">
                      {typeof nodeTitle === "function"
                        ? nodeTitle({
                            node,
                            path,
                            treeIndex,
                          })
                        : nodeTitle}
                    </span>
                  </div>

                  {buttons.map((btn, index) => (
                      <div
                        key={index} // eslint-disable-line react/no-array-index-key
                        // className="mt-1"
                      >
                        {btn}
                      </div>
                    ))}

                  {/* <div className={"rst-row-toolbar"}>
                    {buttons.map((btn, index) => (
                      <div
                        key={index} // eslint-disable-line react/no-array-index-key
                        className={"rst-toolbar-btn"}
                      >
                        {btn}
                      </div>
                    ))}
                  </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );

    return canDrag
      ? connectDragSource(nodeContent, { dropEffect: "copy" })
      : nodeContent;
  }
}

FileThemeNodeContentRenderer.defaultProps = {
  buttons: [],
  canDrag: false,
  canDrop: false,
  className: "",
  draggedNode: null,
  icons: [],
  isSearchFocus: false,
  isSearchMatch: false,
  parentNode: null,
  style: {},
  swapDepth: null,
  swapFrom: null,
  swapLength: null,
  title: null,
  toggleChildrenVisibility: null,
};

FileThemeNodeContentRenderer.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.node),
  canDrag: PropTypes.bool,
  className: PropTypes.string,
  icons: PropTypes.arrayOf(PropTypes.node),
  isSearchFocus: PropTypes.bool,
  isSearchMatch: PropTypes.bool,
  listIndex: PropTypes.number.isRequired,
  lowerSiblingCounts: PropTypes.arrayOf(PropTypes.number).isRequired,
  node: PropTypes.shape({}).isRequired,
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  scaffoldBlockPxWidth: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
  swapDepth: PropTypes.number,
  swapFrom: PropTypes.number,
  swapLength: PropTypes.number,
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  toggleChildrenVisibility: PropTypes.func,
  treeIndex: PropTypes.number.isRequired,
  treeId: PropTypes.string.isRequired,
  rowDirection: PropTypes.string.isRequired,

  // Drag and drop API functions
  // Drag source
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  didDrop: PropTypes.bool.isRequired,
  draggedNode: PropTypes.shape({}),
  isDragging: PropTypes.bool.isRequired,
  parentNode: PropTypes.shape({}), // Needed for dndManager
  // Drop target
  canDrop: PropTypes.bool,
  isOver: PropTypes.bool.isRequired,
};

export default FileThemeNodeContentRenderer;
